import { useCallback } from 'react';

export function useOpenFileInNewTab() {
  const openFileInNewTab = useCallback(async (url: string) => {
    try {
      const response = await fetch(url, { credentials: 'include' });
      if (response.ok) {
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
        window.open(blobUrl, '_blank', 'noopener,noreferrer');
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
      }
    } catch (error) {
      console.error('Failed to open file:', error);
    }
  }, []);

  return { openFileInNewTab };
}
